module.exports = __webpack_public_path__ + "img/packages/h3.45934e.png";